// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../fetch.pb.js";
export var PaymentsProcessor;
(function (PaymentsProcessor) {
    PaymentsProcessor["PAYMENTS_PROCESSOR_UNKNOWN"] = "PAYMENTS_PROCESSOR_UNKNOWN";
    PaymentsProcessor["PAYMENTS_PROCESSOR_STRIPE"] = "PAYMENTS_PROCESSOR_STRIPE";
    PaymentsProcessor["PAYMENTS_PROCESSOR_JUSTIFI"] = "PAYMENTS_PROCESSOR_JUSTIFI";
})(PaymentsProcessor || (PaymentsProcessor = {}));
export var PaymentsProcessor_index;
(function (PaymentsProcessor_index) {
    PaymentsProcessor_index[PaymentsProcessor_index["PAYMENTS_PROCESSOR_UNKNOWN"] = 0] = "PAYMENTS_PROCESSOR_UNKNOWN";
    PaymentsProcessor_index[PaymentsProcessor_index["PAYMENTS_PROCESSOR_STRIPE"] = 1] = "PAYMENTS_PROCESSOR_STRIPE";
    PaymentsProcessor_index[PaymentsProcessor_index["PAYMENTS_PROCESSOR_JUSTIFI"] = 2] = "PAYMENTS_PROCESSOR_JUSTIFI";
})(PaymentsProcessor_index || (PaymentsProcessor_index = {}));
export const PaymentsConfig = {
    GetLocationProcessor(fn, req) {
        return fn(`/payments-platform/payments-config/location/processor?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    GetMultiLocationProcessors(fn, req) {
        return fn(`/payments-platform/payments-config/locations:processors`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
};
